
export default {
  queryString (pagination) {
    return Object.keys(pagination).map(function (key) {
      return key + '=' + pagination[key]
    }).join('&')
  },

  createQueryParam(keyName, value) {
      if (value === '') return {}
      if (value !== null && value !== undefined) {
          return { [ keyName ]: value };
      }
      return {};
  },

  generatePaginationQuery(name = "", items = []) {
      const itemQueries = items?.map((item, index) => {
          const prefix = index === 0 ? '&' : ''
          return `${prefix}${name}=${item}`
      })
      return itemQueries?.join('&')
  }
}
